import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { Login } from './pages/Login'
import { AdminDashboard } from './components/Dashboard/AdminDashboard'
import { SalesDashboard } from './components/Dashboard/SalesDashboard';
import { TeamLeaderDashboard } from './components/Dashboard/TeamLeaderDashboard'
import { ForkliftDashboard } from './components/Dashboard/ForkliftDashboard'
import { TechnicalDashboard } from './components/Dashboard/TechnicalDashboard'
import { SettingsPage } from './components/Settings/SettingsPage'
import { ProblemReporting } from './components/ProblemReporting/ProblemReporting'
import { ProductInspection } from './components/ProductInspection/ProductInspection'
import { useAuth } from './hooks/useAuth'

const ProtectedRoute: React.FC<{ children: React.ReactNode; requiredRole?: string }> = ({ 
  children, 
  requiredRole 
}) => {
  const { user, isLoading, error } = useAuth()

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-100">
        <div className="text-center">
          <div className="text-lg mb-2">Laden...</div>
          {error && <div className="text-red-500 text-sm">Error: {error}</div>}
        </div>
      </div>
    )
  }

  if (!user) {
    return <Navigate to="/login" replace />
  }

  if (requiredRole && user.role !== requiredRole) {
    return <Navigate to="/login" replace />
  }

  return <>{children}</>
}

function App() {
  console.log('🚀 App component rendering')
  
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<Navigate to="/login" replace />} />
      
      {/* Admin Dashboard */}
      <Route
        path="/dashboard/admin"
        element={
          <ProtectedRoute requiredRole="admin">
            <AdminDashboard />
          </ProtectedRoute>
        }
      />
      
      {/* Settings Page */}
      <Route
        path="/settings"
        element={
          <ProtectedRoute requiredRole="admin">
            <SettingsPage />
          </ProtectedRoute>
        }
      />
      
      {/* Other role dashboards can be added here */}
      <Route
        path="/dashboard/sales"
        element={
          <ProtectedRoute requiredRole="sales">
            <SalesDashboard />
          </ProtectedRoute>
        }
      />
      
      <Route
        path="/dashboard/teamleader"
        element={
          <ProtectedRoute requiredRole="teamleader">
            <TeamLeaderDashboard />
          </ProtectedRoute>
        }
      />
      
      <Route
        path="/dashboard/forklift"
        element={
          <ProtectedRoute requiredRole="forklift">
            <ForkliftDashboard />
          </ProtectedRoute>
        }
      />
      
      <Route
        path="/dashboard/technical"
        element={
          <ProtectedRoute requiredRole="technical">
            <TechnicalDashboard />
          </ProtectedRoute>
        }
      />
      
      {/* TeamLeader specific routes */}
      <Route
        path="/problem-report"
        element={
          <ProtectedRoute requiredRole="teamleader">
            <ProblemReporting />
          </ProtectedRoute>
        }
      />
      
      <Route
        path="/product-inspection"
        element={
          <ProtectedRoute requiredRole="teamleader">
            <ProductInspection />
          </ProtectedRoute>
        }
      />
      
      {/* Fallback route */}
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  )
}

export default App
